import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcIntelligence = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.895 10.782c1.085 1.505 2.91 3.125 5.231 4.466 2.321 1.34 4.637 2.11 6.483 2.297 1.923.194 3.02-.259 3.403-.92.381-.661.225-1.838-.905-3.407-1.085-1.505-2.91-3.125-5.231-4.466-2.321-1.34-4.637-2.11-6.483-2.297-1.923-.194-3.02.259-3.403.92-.382.661-.225 1.838.905 3.407Zm-1.217.877c-1.19-1.652-1.848-3.543-.987-5.034.861-1.49 2.827-1.867 4.853-1.662 2.102.212 4.62 1.07 7.082 2.49 2.461 1.422 4.463 3.174 5.698 4.888 1.19 1.652 1.848 3.543.987 5.034-.861 1.491-2.827 1.867-4.853 1.663-2.102-.213-4.62-1.07-7.082-2.491-2.462-1.421-4.463-3.174-5.698-4.888Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.501 5.237C8.739 6.929 8.249 9.32 8.249 12c0 2.68.49 5.071 1.252 6.763.793 1.763 1.734 2.487 2.498 2.487.764 0 1.705-.724 2.498-2.487.762-1.692 1.252-4.083 1.252-6.763 0-2.68-.49-5.071-1.252-6.763C13.704 3.474 12.763 2.75 12 2.75c-.764 0-1.705.724-2.498 2.487ZM8.133 4.62C8.97 2.765 10.277 1.25 12 1.25s3.03 1.515 3.866 3.371C16.733 6.548 17.25 9.158 17.25 12c0 2.842-.517 5.452-1.384 7.379-.835 1.856-2.144 3.371-3.866 3.371s-3.03-1.515-3.866-3.371C7.266 17.452 6.75 14.842 6.75 12c0-2.842.517-5.452 1.384-7.379Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M16.607 6.455c-1.846.187-4.162.957-6.483 2.297-2.321 1.34-4.146 2.96-5.231 4.466-1.13 1.569-1.287 2.746-.905 3.407.382.661 1.48 1.114 3.403.92 1.846-.187 4.162-.957 6.483-2.297 2.321-1.34 4.146-2.96 5.231-4.466 1.13-1.569 1.287-2.746.905-3.407-.382-.661-1.48-1.114-3.403-.92Zm-.15-1.492c2.025-.205 3.991.171 4.852 1.662.86 1.49.203 3.382-.987 5.034-1.235 1.714-3.236 3.466-5.698 4.888-2.462 1.42-4.98 2.278-7.082 2.49-2.026.205-3.992-.171-4.853-1.662-.86-1.491-.203-3.382.987-5.034 1.235-1.714 3.236-3.466 5.698-4.888 2.462-1.42 4.98-2.278 7.082-2.49Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M22.75 6.5a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm-18 11a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcIntelligence");

export { IcIntelligence };
//# sourceMappingURL=ic-intelligence.js.map
